<template>
  <b-card id="attribute-table" class="grid-stack-item-content">
    <div slot="header">
      <window-header :cmp-title="'Attributes for '+(layer.title || layer.name)" :widget-name="layer.id+'attributes'"></window-header>
    </div>

    <div class="d-flex justify-content-between w-100 at-table-options">
      <div class="p-2">
        <b-btn @click="sortBy = null" variant="secondary">Clear sort</b-btn>
        <b-btn :id="'btn_at_columns'+layer.id" @click="sortBy = null" variant="secondary">Columns</b-btn>
        <b-popover :target="'btn_at_columns'+layer.id"
                   title="Columns"
                   triggers="click">
          <template slot="default">
            <div v-if="selectedFields.length > maxFields" class='warning'>More Columns will affect Performace</div>
            <div class="at-column-checkbox">
              <b-form-checkbox-group :options="possibleFields" v-model="selectedFields"></b-form-checkbox-group>
            </div>
          </template>
        </b-popover>
      </div>

      <div class="p-2">
        <b-form-input v-model="filter" placeholder="Filter..."></b-form-input>
      </div>
    </div>
    <div class="at-table-wrapper w-100">
      <b-table class="attribute-table" striped hover show-empty bordered fixed small
               :items="attributes"
               :fields="fields"
               :filter="filter"
               :sort-by.sync="sortBy"
               :current-page="currentPage"
               :per-page="perPage"
               @filtered="onFiltered"
      >

        <template slot="actions" slot-scope="row">
          <b-btn size="sm" @click.stop="zoomTo(row.item)">
            <icon name="search-plus"></icon>
          </b-btn>
        </template>
      </b-table>
    </div>
    <div slot="footer">
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
    </div>
  </b-card>
</template>
<script>
  import 'vue-awesome/icons/search-plus'
  import WindowHeader from '../../common/WindowHeader'
  import WindowFooter from '../../common/WindowFooter'

  export default {
    name: 'attribute-table',
    components: {WindowHeader, WindowFooter},
    data () {
      return {
        maxFields: 7,
        currentPage: 1,
        perPage: 10,
        attributes: [],
        totalRows: 0,
        fields: [],
        possibleFields: [],
        selectedFields: [],
        alldata: [],
        filter: null,
        sortBy: null,
      }
    },
    mounted () {
      this.extractAttributes(true)
    },
    computed: {
      loading () {
        return this.layer.loading
      }
    },
    props: {
      layer: {
        default: null
      }
    },
    watch: {
      loading (val) {
        if (!val) {
          this.extractAttributes(true)
        }
      },
      selectedFields (val) {
        this.fields = [
          { key: 'actions', label: 'Actions', sortable: false }
        ]
        val.forEach(f => {
          this.fields.push({ key: f, label: f, sortable: true })
        })
        this.extractAttributes()
      },
    },
    methods: {

      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      zoomTo (initRow) {
        let row = this.alldata.find(d => initRow.id === d.id)
        let geom = row['geo']
        if (!geom) {
          for (let k in row) {
            if (row.hasOwnProperty(k) && row[k].getExtent) {
              geom = row[k]
              break
            }
          }
        }
        this.$mapService.zoomToGeom(geom)
      },
      extractAttributes (updatePossibleFields) {
        let exists = this.$mapService._layerExists(this.layer)
        if (exists) {
          let data = exists.getSource().getFeatures().map(f => {
            let d = {...f.getProperties()}
            delete d['geometry']
            return d
          })
          if (data.length) {
            let row = data[0]
            if (updatePossibleFields) {
              this.getPossibleFields(row)
            }

            if (this.selectedFields.length) {
              this.attributes = data.map(d => {
                let n = {}
                this.selectedFields.forEach(s => {
                  n[s] = d[s]
                })
                if (this.selectedFields.indexOf('id') == -1) {
                  n['id'] = d['id']
                }
                return n
              })
            }
            this.alldata = data
            this.totalRows = this.attributes.length
          }
        }
      },
      getPossibleFields (row) {
        this.possibleFields = Object.keys(row).filter(f => f.indexOf('zz') !== 0 && f !== 'geo')
        this.fields = []
        this.possibleFields.slice(0, this.maxFields).forEach(f => {
          this.selectedFields.push(f)
        })
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/map/layers/AttributeTable.vue